import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QuizBlockDTO } from '@app/infrastructure/models/quiz-block';
import { BLOCK_TYPES } from '@app/infrastructure/utils/constants';

@Component({
  selector: 'app-shared-multiple-choice-viewer',
  templateUrl: './shared-multiple-choice-viewer.component.html',
  styleUrls: ['./shared-multiple-choice-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedMultipleChoiceViewerComponent {
  @Input() quiz: QuizBlockDTO;

  public blockTypes = BLOCK_TYPES;
}
